import styled from 'styled-components';
import { Text } from "@chakra-ui/core";

export const Container = styled.div`
    position: relative;
    margin-bottom: 20px;
`;

export const Label = styled(Text)`
    position: absolute;
    background-color: white;
    padding: 0 5px;
    font-size: 10px;
    z-index: 99;
    top: -8px;
    left: 8px;
`;

export const Error = styled.p`
    color: red;
    font-size: 10px;
    margin-left: 10px;
`;
